import styled from 'styled-components';

import {
  Flex,
  Text,
} from 'web-styled';

export const Search = styled(Flex).attrs({
  fillSpace: true,
  align: 'center',
})`
  position: relative;
  z-index: 9;

  & > div {
    width: 100%;
  }
`;

export const Label = styled(Text)`
  color: ${props => props.theme.colors.primary};
`;
